(ns frontend.view.grid.counterparty-diligence-grid.person.columns)

;;default set of selected columns
(def ordered-default-columns
  [:person-counterparty-diligence/person-name
   :counterparty-diligence/status
   :person-counterparty-diligence/template
   :counterparty-diligence/note
   :person-counterparty-diligence/screening-status])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:person-counterparty-diligence/person-name})
